import { iconsSet } from "../../../../assets/icons/icons";
import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_quantse.png",
      alt: "Estratégias QuantSE",
    },
    title: "Gradiente Linear",

    // String ou array de strings
    text: "O Trading Sincronizado da estratégia Gradiente Linear permite que você invista no mercado financeiro com mais segurança e rentabilidade, por meio da cópia automática de negociações realizadas por algoritmos quantitativos. Através de plataformas homologadas pela CVM, você pode selecionar esses algoritmos, acompanhar as operações em tempo real e diversificar sua carteira de investimentos com a negociação de ativos financeiros, como Índice Bovespa e Dólar Futuro. Invista com confiança e maximize seus ganhos agora com o Copy Trading da estratégia Gradiente Linear by QuantSE e Liga dos Traders.",
    testimonial: {
      text: "Racionalidade e respeito pela modelagem estatística regem nosso trabalho.",
      author: {
        name: "QuantSE",
        // picture: "",
      },
    },
  },

  strategies: {
    title: "Investimento e Estatística",
    heading: "Algoritmos criados a partir de modelagem matemática",
    subtitle:
      "Nossos algoritmos passam por uma validação estatística utilizando anos de dados. Só após essa comprovação, testes e verificação de aderência entre backtesting + conta demo + conta real, é que disponibilizamos para assinatura.",
  },

  cta: {
    title: "Quer investir sem fantasias?",
    subtitle:
      "Ative agora uma cópia de nossas estratégias e invista com a matemática ao seu favor.",
    // buttonText: "Ativar Estratégias",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "QuantSE",
    col1: [
      "A empresa tem como foco o desenvolvimento de tecnologias voltadas ao mercado financeiro mundial, através da utilização de modelagem matemática quantitativa, isto é, aplicando conceitos matemáticos para descobrir oportunidades ou distorções em ativos financeiros. Dessa forma, a QuantSE desenvolve ferramentas de pesquisa, análise e execução automatizada, fazendo uma varredura no mercado e aproveitando oportunidades que seriam impossíveis de serem feitas simultaneamente por humanos.",
    ],
    // col2: [""],
  },

  stats: {
    title: "Estatística GL Agressivo 2022",
    subtitle: "Como foi nossa performance no último ano?",
    data: [
      {
        value: "80%",
        description: "Retorno líquido (considerando 10k de margem)",
      },
      {
        value: "333",
        description: "Operações",
      },
      {
        value: "9",
        description: "meses positivos no ano",
      },
    ],
  },

  features: {
    title: "Por que utilizar os robôs da QuantSE?",
    subtitle: "Veja quais as principais vantagens dos robôs da QuantSE.",
    data: [
      {
        icon: iconsSet.calendar,
        title: "7 dias para testar",
        description:
          "Teste nossas estratégias e confira os resultados em sua conta.",
      },
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description:
          "Não se preocupe com nada, todos ajustes e parâmetros são realizados por nós.",
      },
      {
        icon: iconsSet.chat,
        title: "Suporte Individual",
        description:
          "Priorizamos um atendimento individual de qualidade através do nosso atendimento humanizado, proporcionando uma experiência exclusiva.",
      },
      ...defaultContent.features.data,
    ],
  },

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão QuantSE",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
